import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import styled from 'styled-components';
const EditVisitDiv = styled.div.withConfig({
  displayName: "VisitFees__EditVisitDiv",
  componentId: "sc-10edx5y-0"
})(["display:flex;justify-content:flex-start;flex-direction:left;flex-wrap:wrap;"]);
const useStyles = makeStyles(theme => ({
  input: {
    padding: '8px',
    fontSize: '1rem'
  },
  label: {
    fontSize: '1.1rem'
  },
  margin: {
    margin: theme.spacing(1)
  },
  textField: {
    width: '95px',
    marginTop: '15px',
    flexDirection: 'row',
    marginBottom: '0px'
  }
}));

var _ref = /*#__PURE__*/React.createElement(InputAdornment, {
  position: "start"
}, "mi");

var _ref2 = /*#__PURE__*/React.createElement(InputAdornment, {
  position: "start"
}, "min");

var _ref3 = /*#__PURE__*/React.createElement(InputAdornment, {
  position: "start"
}, "$");

var _ref4 = /*#__PURE__*/React.createElement(InputAdornment, {
  position: "start"
}, "$");

export const VisitFees = ({
  transitFees,
  travelMileage,
  travelDuration,
  tollsFee,
  onTransitFeeChange,
  onMileageChange,
  onTravelTimeChange,
  onTollFeeChange
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(EditVisitDiv, {
    id: "edit-VisitFees"
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Mileage",
    id: "travelMileage",
    value: travelMileage,
    className: clsx(classes.margin, classes.textField),
    InputProps: {
      startAdornment: _ref,
      classes: {
        input: classes.input
      }
    },
    InputLabelProps: {
      classes: {
        formControl: classes.label
      }
    },
    variant: "outlined",
    onChange: onMileageChange // eslint-disable-next-line react/jsx-no-duplicate-props
    ,
    inputProps: {
      maxLength: 5
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    label: "Travel Time",
    id: "travel-time",
    value: travelDuration,
    className: clsx(classes.margin, classes.textField),
    InputProps: {
      startAdornment: _ref2,
      classes: {
        input: classes.input
      }
    },
    InputLabelProps: {
      classes: {
        formControl: classes.label
      }
    },
    variant: "outlined",
    onChange: onTravelTimeChange // eslint-disable-next-line react/jsx-no-duplicate-props
    ,
    inputProps: {
      maxLength: 5
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    label: "Tolls Fees",
    id: "tolls-VisitFees",
    value: tollsFee,
    className: clsx(classes.margin, classes.textField),
    InputProps: {
      startAdornment: _ref3,
      classes: {
        input: classes.input
      }
    },
    InputLabelProps: {
      classes: {
        formControl: classes.label
      }
    },
    variant: "outlined",
    onChange: onTollFeeChange // eslint-disable-next-line react/jsx-no-duplicate-props
    ,
    inputProps: {
      maxLength: 5
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    label: "Transit Fees",
    id: "transit-VisitFees",
    value: transitFees,
    className: clsx(classes.margin, classes.textField),
    InputProps: {
      startAdornment: _ref4,
      classes: {
        input: classes.input
      }
    },
    InputLabelProps: {
      classes: {
        formControl: classes.label
      }
    },
    variant: "outlined",
    onChange: onTransitFeeChange // eslint-disable-next-line react/jsx-no-duplicate-props
    ,
    inputProps: {
      maxLength: 5
    }
  }));
};
export default VisitFees;